export const exercisesCatalog = [
  // --- МОДУЛЬ 1: РЕЧЬ ---
  {
    id: 'speech_repeat',
    title: 'Повтори фразу',
    description: 'Тренировка четкости речи. Повторите предложение за диктором.',
    domain: 'Речь',
    icon: '🗣️',
    color: 'bg-blue-50 border-blue-200'
  },
  {
    id: 'speech_read',
    title: 'Чтение вслух',
    description: 'Прочитайте короткий текст четко и без запинок.',
    domain: 'Речь',
    icon: '📖',
    color: 'bg-blue-50 border-blue-200'
  },

  // --- МОДУЛЬ 2: КОГНИТИВНЫЕ НАВЫКИ ---
  
  {
  id: 'fluency',
  domain: 'Речь',
  title: 'Речевая беглость',
  description: 'Назвать как можно больше слов на заданную букву за 1 минуту. 20 заданий на 40 дней.',
  icon: '🗣️',
  href: '/trainer',
},
  
{
  id: 'visual',
  domain: 'Когнитивные навыки',
  title: 'Зрительное восприятие',
  description: 'Назвать предметы/буквы на зашумленной картинке. 20 заданий на 40 дней.',
  icon: '👁️',
  href: '/visual',
},

{
  id: 'retell',
  domain: 'Связная речь',
  title: 'Пересказ близко к тексту',
  description: 'Прочитать рассказ и пересказать своими словами. Пока 4 рассказа — банк растёт.',
  icon: '📖',
  href: '/retell',
},

  {
    id: 'cog_memory',
    title: 'Найди пару',
    description: 'Тренировка зрительной памяти. Найдите одинаковые карточки.',
    domain: 'Когнитивные навыки',
    icon: '🧠',
    color: 'bg-purple-50 border-purple-200'
  },
  {
    id: 'cog_stroop',
    title: 'Цвета и слова',
    description: 'Назовите цвет слова, игнорируя его значение.',
    domain: 'Когнитивные навыки',
    icon: '🌈',
    color: 'bg-purple-50 border-purple-200'
  },
  {
    id: 'cog_speed',
    title: 'Быстрые цифры',
    description: 'Сопоставьте символы и цифры как можно быстрее.',
    domain: 'Когнитивные навыки',
    icon: '⚡',
    color: 'bg-purple-50 border-purple-200'
  },

  // --- МОДУЛЬ 3: МИМИКА (Исправленные описания) ---
  {
    id: 'smiley-face',
    title: 'Улыбка',
    description: 'Растяните губы и улыбнитесь',
    domain: 'Мимика',
    icon: '😁',
    color: 'bg-pink-50 border-pink-200'
  },
  {
    id: 'open-close-mouth',
    title: 'Открой рот',
    description: 'Откройте рот и округлите губы как будто говорите аааа',
    domain: 'Мимика',
    icon: '😮',
    color: 'bg-pink-50 border-pink-200'
  },
  {
    id: 'show-teeth',
    title: 'Заборчик',
    description: 'Растяните губы пошире и покажите зубы',
    domain: 'Мимика',
    icon: '😬',
    color: 'bg-pink-50 border-pink-200'
  },
  {
    id: 'brows-up',
    title: 'Удивись',
    description: 'Поднимите брови',
    domain: 'Мимика',
    icon: '😲',
    color: 'bg-pink-50 border-pink-200'
  },
{
    id: 'kisses',
    title: 'Поцелуйчик',
    description: 'Вытяните губы вперёд, как для поцелуя',
    domain: 'Мимика',
    icon: '😚',
    color: 'bg-pink-50 border-pink-200'
  },

{
    id: 'round-lips',
    title: 'Слоник',
    description: 'Вытяните губы вперёд трубочкой',
    domain: 'Мимика',
    icon: '🐘',
    color: 'bg-pink-50 border-pink-200'
  },



  // --- МОДУЛЬ 4: МОТОРИКА ---
  {
    id: 'motor_tap',
    title: 'Точность движений',
    description: 'Нажимайте на мишени на экране как можно быстрее.',
    domain: 'Моторика',
    icon: '👆',
    color: 'bg-green-50 border-green-200'
  },
  {
    id: 'motor_draw',
    title: 'Обводка фигур',
    description: 'Тренировка координации. Обведите фигуру точно по контуру.',
    domain: 'Моторика',
    icon: '✏️',
    color: 'bg-green-50 border-green-200'
  }
];